import axiosInstance from '../axiosInterceptor/axiosInstance'

const getCountries = async () => {
  const url = '/clubs/countries'
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getCountries
